export default "__VITE_ASSET__fa0437fd__"